import { create } from "zustand";

type CategoryModalState = {
  isOpen: boolean;
  categoryId: string | null;
  defaultValues: Partial<{
    name: string;
    description: string;
    color: string;
    sortOrder: number;
  }>;
  setIsModalOpen: (isOpen: boolean) => void;
  setCategoryId: (id: string | null) => void;
  setDefaultValues: (
    values: Partial<{
      name: string;
      description: string;
      color: string;
      sortOrder: number;
    }>,
  ) => void;
};

type ResourceModalState = {
  isOpen: boolean;
  resourceId: string | null;
  defaultValues: Partial<{
    categoryId: string;
    name: string;
    description: string;
    fileType: string;
    fileSize: string;
    isPublished: boolean;
    sortOrder: number;
    mediaId: string;
    externalUrl: string;
  }>;
  setIsModalOpen: (isOpen: boolean) => void;
  setResourceId: (id: string | null) => void;
  setDefaultValues: (
    values: Partial<{
      categoryId: string;
      name: string;
      description: string;
      fileType: string;
      fileSize: string;
      isPublished: boolean;
      sortOrder: number;
      mediaId: string;
      externalUrl: string;
    }>,
  ) => void;
};

export const useCategoryModal = create<CategoryModalState>((set) => ({
  isOpen: false,
  categoryId: null,
  defaultValues: {},
  setIsModalOpen: (isOpen) => set({ isOpen }),
  setCategoryId: (id) => set({ categoryId: id }),
  setDefaultValues: (values) => set({ defaultValues: values }),
}));

export const useResourceModal = create<ResourceModalState>((set) => ({
  isOpen: false,
  resourceId: null,
  defaultValues: {},
  setIsModalOpen: (isOpen) => set({ isOpen }),
  setResourceId: (id) => set({ resourceId: id }),
  setDefaultValues: (values) => set({ defaultValues: values }),
}));
